import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../../../utils/useTranslation';
import { SmartDrawer } from '../../../../feedback/SmartDrawer';
import { IconHelp } from '../../../../icon/IconHelp';
import { Button } from '../../../../input/Button';
import { Box } from '../../../../layout/Box';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { DIRECT_LINK, PROMO_TEXT, SUPPORT_LINK } from './constants';
import { StartTypography } from './styles';

export const ContentPromotionStart: React.FC<{}> = () => {
    const t = useTranslation();
    const [visibleInfoModal, setVisibleInfoModal] = useState(false);
    const onClick = useCallback(() => setVisibleInfoModal(true), []);
    const onClose = useCallback(() => setVisibleInfoModal(false), []);
    const directLink = (
        <Typography
            variant="body2"
            display="inline"
            as={Link}
            to={DIRECT_LINK}
            color="link"
            textDecoration="none"
            target="_blank"
        >
            {t('по ссылке')}
        </Typography>
    );
    const supportLink = (
        <Typography
            variant="body2"
            display="inline"
            as={Link}
            to={SUPPORT_LINK}
            color="link"
            textDecoration="none"
            target="_blank"
        >
            {t('в справке')}
        </Typography>
    );

    return (
        <>
            <Box>
                <StartTypography display="inline">{t(PROMO_TEXT)}</StartTypography>
                <Box display="inline-block" verticalAlign="sub" ml={0.5}>
                    <IconHelp
                        dataTestId={DataTestId.ABOUT_CONTENT_PROMOTION_ICON_TEST_ID}
                        color="var(--color-secondary)"
                        cursor="pointer"
                        size={16}
                        onClick={onClick}
                    />
                </Box>
            </Box>
            {visibleInfoModal
                ? createPortal(
                      <SmartDrawer
                          dataTestId={DataTestId.ABOUT_CONTENT_PROMOTION_MODAL_TEST_ID}
                          onClose={onClose}
                          titleContent={
                              <Typography variant="title3" weight="bold">
                                  {t('Продвижение контента')}
                              </Typography>
                          }
                          mainContent={(closeHandler) => (
                              <Flex direction="column" spacing={1} maxWidth="100%">
                                  <Typography
                                      variant="body2"
                                      maxWidth="100%"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                  >
                                      {t(
                                          'Для платного продвижения нужно авторизоваться в вашем аккаунте в Яндекс.Директе. Если у вас нет аккаунта зарегистрируйте его ',
                                      )}
                                      {directLink}
                                  </Typography>
                                  <Typography
                                      variant="body2"
                                      maxWidth="100%"
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                  >
                                      {t('Подробнее про возможности платного продвижения читайте ')}
                                      {supportLink}
                                  </Typography>
                                  <Box pt={2} width="100%">
                                      <Button size="l" width="100%" onClick={closeHandler}>
                                          {t('Хорошо')}
                                      </Button>
                                  </Box>
                              </Flex>
                          )}
                      />,
                      document.body,
                  )
                : null}
        </>
    );
};
